import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {ProductImage} from "../../models/product";
import {environment} from '../../env';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ProductImageService {

  constructor(private http: HttpClient) {
  }

  getImages(productId: number): Observable<ProductImage[]> {
    return this.http.get<ProductImage[]>(`${environment.apiUrl}/products/${productId}/images`);
  }

  uploadImage(productId: number, file: File, isPrimary: boolean = true): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('is_primary', isPrimary.toString());

    return this.http.post(`${environment.apiUrl}/products/${productId}/images`, formData);
  }

  deleteImage(imageId: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/product-images/${imageId}`);
  }

  setAsPrimaryImage(imageId: number): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/product-images/${imageId}/is-primary`, {});
  }

  /**
   * Removes the background from a stored image and adds the cut-out to the
   * product as a new photo. The source image is left untouched, so an
   * unconvincing result is undone by deleting the new one.
   *
   * The call is synchronous and runs a remote model — expect a few seconds.
   */
  enhanceImage(imageId: number): Observable<any> {
    return this.http.post(`${environment.apiUrl}/product-images/${imageId}/enhance`, {});
  }
}
